import { useState } from 'react';
import LuxPageHero from '../components/lux/LuxPageHero';
import LuxReveal from '../components/lux/LuxReveal';
import { Icon } from '../components/ui/Icons';
import { courseNames } from '../data/courses';

const benefits = [
  { icon: 'graduation', title: 'Free Career Counselling', desc: 'Expert guidance to choose the right course.' },
  { icon: 'zap', title: 'Quick Response', desc: 'We respond within 2 hours on WhatsApp.' },
  { icon: 'briefcase', title: 'Easy EMI Options', desc: 'Flexible plans from ₹999/month.' },
  { icon: 'trophy', title: '100% Placement Support', desc: 'Resume, mocks & recruiter connects.' },
];

export default function Admission() {
  const [form, setForm] = useState({ name: '', phone: '', edu: '', course: courseNames[0], message: '' });
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const submit = () => {
    if (!form.name.trim()) return alert('Please enter your Full Name.');
    if (!form.phone.trim() || form.phone.length < 10) return alert('Please enter a valid Phone Number.');
    const msg =
      `*Bharat Training — Admission*%0AName: ${form.name}%0APhone: ${form.phone}%0AEducation: ${form.edu || 'Not mentioned'}%0ACourse: ${form.course}%0A` +
      `${form.message ? `Message: ${form.message}%0A` : ''}Please share fee details and batch schedule.`;
    window.open(`https://wa.me/918851868521?text=${msg}`, '_blank');
  };

  return (
    <>
      <LuxPageHero
        label="Get Started"
        title="Start Your"
        highlight="Industrial Journey"
        description="Free counselling. No pressure. Our team guides you to the right batch in Noida."
      />

      <section className="lux-page-section">
        <div className="container-wide lux-grid-2 admission-grid">
          <div>
            {benefits.map((b, i) => (
              <LuxReveal key={b.title} delay={i * 0.08}>
                <div style={{ display: 'flex', gap: 16, marginBottom: 24 }}>
                  <div className="icon-wrap" style={{ width: 46, height: 46 }}><Icon name={b.icon} size={20} /></div>
                  <div>
                    <h4 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, marginBottom: 6 }}>{b.title}</h4>
                    <p style={{ color: 'var(--text-muted)', fontSize: 14 }}>{b.desc}</p>
                  </div>
                </div>
              </LuxReveal>
            ))}
          </div>

          <LuxReveal delay={0.12} x={28}>
            <div className="lux-form-panel">
              <h2>Fast-Track <span className="accent">Admission</span></h2>
              <p style={{ color: 'var(--text-muted)', fontSize: 14, marginBottom: 28 }}>Submit details — continue on WhatsApp.</p>

              <div className="form-field">
                <label className="form-label">Full Name *</label>
                <input className="form-input" type="text" value={form.name} onChange={e => set('name', e.target.value)} placeholder="Your name" />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }} className="form-row-2">
                <div className="form-field">
                  <label className="form-label">Phone *</label>
                  <input className="form-input" type="tel" value={form.phone} onChange={e => set('phone', e.target.value)} placeholder="+91..." />
                </div>
                <div className="form-field">
                  <label className="form-label">Education</label>
                  <input className="form-input" type="text" value={form.edu} onChange={e => set('edu', e.target.value)} placeholder="B.Tech / Diploma..." />
                </div>
              </div>
              <div className="form-field">
                <label className="form-label">Preferred Course</label>
                <select className="form-input" value={form.course} onChange={e => set('course', e.target.value)}>
                  {courseNames.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              <div className="form-field">
                <label className="form-label">Message (optional)</label>
                <textarea className="form-input" rows={3} value={form.message} onChange={e => set('message', e.target.value)} />
              </div>
              <button type="button" className="btn-lux btn-lux--fill" style={{ width: '100%', justifyContent: 'center', color: '#030712', border: 'none', cursor: 'pointer' }} onClick={submit}>
                Submit via WhatsApp
              </button>
              <p style={{ textAlign: 'center', fontSize: 12, color: 'var(--text-muted)', marginTop: 14 }}>Attach documents on WhatsApp after submitting.</p>
            </div>
          </LuxReveal>
        </div>
      </section>
    </>
  );
}
